import React, { useState, lazy, Suspense, memo, useContext } from 'react';
import { SttTabs, SttContainerTitle, SttTranslateHook } from '@stt-componentes/core-v2';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    wrapper: {
        padding: theme.spacing(1)
    }
}));

const Stt = lazy(() => import('./stt/Stt'));
const Bridges = lazy(() => import('./bridges/Bridges'));

const SttSuspense = memo((props) => {
    return (
        <Suspense>
            <SttContainerTitle titulo="PACS/STT" />
            <Stt {...props} />
        </Suspense>
    );
});

const BridgesSuspense = memo((props) => {
    return (
        <Suspense>
            <SttContainerTitle titulo="PACS/BRIDGE" />
            <Bridges {...props} />
        </Suspense>
    );
});

const IndexPacs = ({ props }) => {
    const { strings } = useContext(SttTranslateHook.I18nContext);
    const classes = useStyles();

    const abas = [
        {
            titulo: strings.stt,
            conteudo: SttSuspense,
            key: 'SttSuspense',
            permanente: true,
        },
        {
            titulo: strings.bridges,
            conteudo: BridgesSuspense,
            key: 'BridgesSuspense',
            permanente: true,
        },
    ];

    const [abaAtiva, setAbaAtiva] = useState('0');

    return <SttTabs abas={abas} className={classes.wrapper} handleChangeAbaAtiva={setAbaAtiva} abaAtiva={abaAtiva} permanente={true} preload={false} />;
};

export default IndexPacs;
